// source: witbooking/loyalty/tag/v1/loyalty_tag_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.CreateTagRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.DeleteTagRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.GetTagRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.GetTagResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.GetTagSectionRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.GetTagSectionResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.ListTagsRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.ListTagsResponse', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.LoyaltyTag', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.LoyaltyTagSection', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionType', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.LoyaltyTagType', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.UpdateTagRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.tag.v1.LoyaltyTag.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.LoyaltyTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.LoyaltyTag.displayName = 'proto.witbooking.loyalty.tag.v1.LoyaltyTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.LoyaltyTagSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.displayName = 'proto.witbooking.loyalty.tag.v1.LoyaltyTagSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.Translation.displayName = 'proto.witbooking.loyalty.tag.v1.Translation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.ListTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.ListTagsRequest.displayName = 'proto.witbooking.loyalty.tag.v1.ListTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.tag.v1.ListTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.ListTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.ListTagsResponse.displayName = 'proto.witbooking.loyalty.tag.v1.ListTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.GetTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.GetTagRequest.displayName = 'proto.witbooking.loyalty.tag.v1.GetTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.GetTagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.GetTagResponse.displayName = 'proto.witbooking.loyalty.tag.v1.GetTagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.CreateTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.CreateTagRequest.displayName = 'proto.witbooking.loyalty.tag.v1.CreateTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.UpdateTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.UpdateTagRequest.displayName = 'proto.witbooking.loyalty.tag.v1.UpdateTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.DeleteTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.DeleteTagRequest.displayName = 'proto.witbooking.loyalty.tag.v1.DeleteTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.displayName = 'proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.displayName = 'proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.displayName = 'proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.displayName = 'proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.displayName = 'proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.displayName = 'proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.displayName = 'proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.GetTagSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.displayName = 'proto.witbooking.loyalty.tag.v1.GetTagSectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.GetTagSectionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.displayName = 'proto.witbooking.loyalty.tag.v1.GetTagSectionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.displayName = 'proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.displayName = 'proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.displayName = 'proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.displayName = 'proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 4, ""),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.loyalty.tag.v1.Translation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.LoyaltyTag;
  return proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 5:
      var value = /** @type {!proto.witbooking.loyalty.tag.v1.LoyaltyTagType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = new proto.witbooking.loyalty.tag.v1.Translation;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.loyalty.tag.v1.Translation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brandId = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string icon = 4;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional LoyaltyTagType type = 5;
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagType}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.getType = function() {
  return /** @type {!proto.witbooking.loyalty.tag.v1.LoyaltyTagType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTagType} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated Translation translations = 6;
 * @return {!Array<!proto.witbooking.loyalty.tag.v1.Translation>}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.tag.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.tag.v1.Translation, 6));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.tag.v1.Translation>} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
*/
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.tag.v1.Translation}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.loyalty.tag.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTag.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    brandid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 3, ""),
    order: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.loyalty.tag.v1.Translation.toObject, includeInstance),
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.LoyaltyTagSection;
  return proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 5:
      var value = /** @type {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = new proto.witbooking.loyalty.tag.v1.Translation;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 7:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTag;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.loyalty.tag.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brandId = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ticker = 3;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 order = 4;
 * @return {number}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional LoyaltyTagSectionType type = 5;
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionType}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getType = function() {
  return /** @type {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionType} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated Translation translations = 6;
 * @return {!Array<!proto.witbooking.loyalty.tag.v1.Translation>}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.tag.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.tag.v1.Translation, 6));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.tag.v1.Translation>} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
*/
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.tag.v1.Translation}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.loyalty.tag.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * repeated LoyaltyTag tags = 7;
 * @return {!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTag>}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTag, 7));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTag>} value
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
*/
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.witbooking.loyalty.tag.v1.LoyaltyTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} returns this
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    translation: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.Translation}
 */
proto.witbooking.loyalty.tag.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.Translation;
  return proto.witbooking.loyalty.tag.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.Translation}
 */
proto.witbooking.loyalty.tag.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranslation(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTranslation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.Translation} returns this
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string translation = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.getTranslation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.Translation} returns this
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.setTranslation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.Translation} returns this
 */
proto.witbooking.loyalty.tag.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.ListTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    globals: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsRequest}
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.ListTagsRequest;
  return proto.witbooking.loyalty.tag.v1.ListTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsRequest}
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGlobals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.ListTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGlobals();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool globals = 2;
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.prototype.getGlobals = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.ListTagsRequest.prototype.setGlobals = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.ListTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsResponse}
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.ListTagsResponse;
  return proto.witbooking.loyalty.tag.v1.ListTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsResponse}
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTag;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.ListTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LoyaltyTag tags = 1;
 * @return {!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTag>}
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTag, 1));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTag>} value
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsResponse} returns this
*/
proto.witbooking.loyalty.tag.v1.ListTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.loyalty.tag.v1.LoyaltyTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagsResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.ListTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.GetTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagRequest}
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.GetTagRequest;
  return proto.witbooking.loyalty.tag.v1.GetTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagRequest}
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.GetTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.GetTagRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.GetTagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tag: (f = msg.getTag()) && proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagResponse}
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.GetTagResponse;
  return proto.witbooking.loyalty.tag.v1.GetTagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagResponse}
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTag;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.GetTagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyTag tag = 1;
 * @return {?proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.prototype.getTag = function() {
  return /** @type{?proto.witbooking.loyalty.tag.v1.LoyaltyTag} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTag, 1));
};


/**
 * @param {?proto.witbooking.loyalty.tag.v1.LoyaltyTag|undefined} value
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagResponse} returns this
*/
proto.witbooking.loyalty.tag.v1.GetTagResponse.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.GetTagResponse.prototype.hasTag = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.CreateTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tag: (f = msg.getTag()) && proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagRequest}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.CreateTagRequest;
  return proto.witbooking.loyalty.tag.v1.CreateTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagRequest}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTag;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.CreateTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LoyaltyTag tag = 2;
 * @return {?proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.getTag = function() {
  return /** @type{?proto.witbooking.loyalty.tag.v1.LoyaltyTag} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTag, 2));
};


/**
 * @param {?proto.witbooking.loyalty.tag.v1.LoyaltyTag|undefined} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} returns this
*/
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.CreateTagRequest.prototype.hasTag = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.UpdateTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tag: (f = msg.getTag()) && proto.witbooking.loyalty.tag.v1.LoyaltyTag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.UpdateTagRequest;
  return proto.witbooking.loyalty.tag.v1.UpdateTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTag;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.UpdateTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LoyaltyTag tag = 2;
 * @return {?proto.witbooking.loyalty.tag.v1.LoyaltyTag}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.getTag = function() {
  return /** @type{?proto.witbooking.loyalty.tag.v1.LoyaltyTag} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTag, 2));
};


/**
 * @param {?proto.witbooking.loyalty.tag.v1.LoyaltyTag|undefined} value
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} returns this
*/
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagRequest.prototype.hasTag = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.DeleteTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.DeleteTagRequest;
  return proto.witbooking.loyalty.tag.v1.DeleteTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.DeleteTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.DeleteTagRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    content: msg.getContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest;
  return proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes content = 2;
 * @return {!(string|Uint8Array)}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes content = 2;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    created: jspb.Message.getFieldWithDefault(msg, 1, 0),
    deleted: jspb.Message.getFieldWithDefault(msg, 2, 0),
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse;
  return proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreated(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeleted(value);
      break;
    case 3:
      var value = new proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreated();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDeleted();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 created = 1;
 * @return {number}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.getCreated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.setCreated = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 deleted = 2;
 * @return {number}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.getDeleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated CreateMultipleTagsExcelError errors = 3;
 * @return {!Array<!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError>}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError, 3));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError>} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} returns this
*/
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    errorcode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    errormessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError;
  return proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorcode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getErrorcode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string errorCode = 3;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.getErrorcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.setErrorcode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string errorMessage = 4;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelError.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest;
  return proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    content: msg.getContent_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse;
  return proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes content = 1;
 * @return {!(string|Uint8Array)}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.prototype.getContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes content = 1;
 * This is a type-conversion wrapper around `getContent()`
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.prototype.getContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getContent()));
};


/**
 * optional bytes content = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContent()`
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.prototype.getContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.prototype.setContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest;
  return proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse;
  return proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTagSection;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LoyaltyTagSection sections = 1;
 * @return {!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection>}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTagSection, 1));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection>} value
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse} returns this
*/
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.tag.v1.LoyaltyTagSection}
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.loyalty.tag.v1.LoyaltyTagSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.GetTagSectionRequest;
  return proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    section: (f = msg.getSection()) && proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.GetTagSectionResponse;
  return proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTagSection;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinaryFromReader);
      msg.setSection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSection();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyTagSection section = 1;
 * @return {?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.prototype.getSection = function() {
  return /** @type{?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTagSection, 1));
};


/**
 * @param {?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection|undefined} value
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse} returns this
*/
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.prototype.setSection = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse} returns this
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.prototype.clearSection = function() {
  return this.setSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.prototype.hasSection = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    section: (f = msg.getSection()) && proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest;
  return proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTagSection;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinaryFromReader);
      msg.setSection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSection();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LoyaltyTagSection section = 2;
 * @return {?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.getSection = function() {
  return /** @type{?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTagSection, 2));
};


/**
 * @param {?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection|undefined} value
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} returns this
*/
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.setSection = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.clearSection = function() {
  return this.setSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest.prototype.hasSection = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    section: (f = msg.getSection()) && proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest;
  return proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = new proto.witbooking.loyalty.tag.v1.LoyaltyTagSection;
      reader.readMessage(value,proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.deserializeBinaryFromReader);
      msg.setSection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSection();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.loyalty.tag.v1.LoyaltyTagSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LoyaltyTagSection section = 2;
 * @return {?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.getSection = function() {
  return /** @type{?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.loyalty.tag.v1.LoyaltyTagSection, 2));
};


/**
 * @param {?proto.witbooking.loyalty.tag.v1.LoyaltyTagSection|undefined} value
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} returns this
*/
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.setSection = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.clearSection = function() {
  return this.setSection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest.prototype.hasSection = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest;
  return proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    afterid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest;
  return proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAfterid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string brandId = 1;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.getBrandid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.setBrandid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string afterId = 3;
 * @return {string}
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.getAfterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} returns this
 */
proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest.prototype.setAfterid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagType = {
  PREFERENCE: 0
};

/**
 * @enum {number}
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionType = {
  PREFERENCE_SECTION: 0
};

goog.object.extend(exports, proto.witbooking.loyalty.tag.v1);
